<template>
    <div>
        <div style="height:50px"></div>
        <div class="footer">
            <div v-for='(item,index) of items' :class='[{on:index === idx}]' :key="index" @click="click(index)">
                <div v-if="item.push!=='/home'">
                    <img :src="index===idx?item.iconSelect:item.icon" />
                    <p :class="index===idx?'foorerThis':''">{{item.name}}</p>
                </div>
                <div v-else class="home">
                    <div>
                        <img :src="item.icon"/>
                        <p>首页</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="home-shade"></div>
    </div>
</template>
<script>
export default {
    name: "FooterShop",
    props: ['idx'],
    data() {
        return {
            items: [{
                name: "吉祥阁",
                push: "/shop1",
                icon: this.Images.icon_tabbar_shop,
                iconSelect: this.Images.icon_tabbar_shop_cur,
            },
            {
                name: "金钥匙",
                push: "/shop2",
                icon: this.Images.icon_tabbar_shop1,
                iconSelect: this.Images.icon_tabbar_shop1_cur,
            },
            {
                name: "首页",
                push: "/home",
                icon: this.Images.icon_tabbar_home_center,
                iconSelect: this.Images.icon_tabbar_home_center,
            },
            {
                name: "购物车",
                push: "/cart",
                icon: this.Images.icon_tabbar_cart,
                iconSelect: this.Images.icon_tabbar_cart_cur,
            },
            {
                name: "订单",
                push: "/order",
                icon: this.Images.icon_tabbar_order,
                iconSelect: this.Images.icon_tabbar_order_cur,
            }]
        };
    },
    methods: {
        // 方法
        click(index) {
            if (this.idx == index) return;
            let token = this.Lockr.get('token')
            console.log('token---->', token);
            if (!token && index > 2) {
                this.$emit(this.Constants.SHOWLOGINDIALOG, true);
            } else {
                this.$router.push(this.items[index].push)
            }
        }

    },
    created() {
        // 实例创建完成
    },
};
</script>
<style lang="less" scoped>
.footer {
    display: flex;
    position: fixed;
    left: 0;
    bottom: 0;
    box-sizing: border-box;
    height: 50px;
    background: #fff;
    width: 100%;
    // border-top: 1px solid #d8d8d8;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    z-index: 10;

    > div {
        position: relative;
        z-index: 2;
        width: 25%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        > div {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            img {
                display: block;
                width: 20px;
            }
            > p {
                font-size: 12px;
                font-weight: 500;
                color: #999999;
            }
            .foorerThis {
                color: #7282eb;
            }
        }
        .home {
            position: absolute;
            z-index: 11;
            bottom: 0;
            height: 68px;
            width: 68px;
            border-radius: 50%;
            background: #fff;
            > div {
                width: 50px;
                height: 50px;
                border-radius: 50%;
                background: #E2E5FB;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;

                img {
                    display: block;
                    width: 20px;
                }

                > p {
                    font-size: 12px;
                    color: #7282EB;
                }
            }
        }
    }
}
.home-shade{
    position: fixed;
    z-index: 9;
    bottom: 0;
    height: 68px;
    width: 68px;
    border-radius: 50%;
    background: #fff;
    left: 50%;
    transform: translateX(-50%);
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
}
</style>